module.exports = __webpack_public_path__ + "img/hair_color_red.705c19b.svg";